import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";

@Injectable()
export class TagInformationService {

  private subject = new Subject<any>();

  setTag(tag: string, source: string, fieldValueToSearch?: string) {
    this.subject.next(fieldValueToSearch ? {tag: tag, fieldValueToSearch: fieldValueToSearch, source: source} : {tag: tag, source: source});
  }

  reset(source: string) {
    this.subject.next({tag: '', source: source});
  }

  getTag(): Observable<{tag: string, fieldValueToSearch: string, source: string}> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/providers/tag.information.service.ts